export default {
  annuitylogowithafl: require('../assets/images/AnnuityLogoWithAFL.png'),
  Camera: require('../assets/images/Camera.png'),
  Done: require('../assets/images/Done.png'),
  EditPicFrame: require('../assets/images/EditPicFrame.png'),
  placeholderimage: require('../assets/images/PlaceholderImage.jpg'),
  officedotlogo: require('../assets/images/OfficeDotLogo.png'),
};
